/** Mirrors backend TokenAction enum (node-deposits-panel). */
export enum JwtTokenAction {
  AccessToken = 1,
  TwoFactorAuth = 3,
  ConfirmEmail = 4,
}

export function parseJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = atob(base64);
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function getTokenAction(token: string): number | null {
  const payload = parseJwtPayload(token);
  if (!payload || typeof payload.action !== 'number') {
    return null;
  }

  return payload.action;
}

export function isFullAccessToken(token: string): boolean {
  return getTokenAction(token) === JwtTokenAction.AccessToken;
}

export function isPendingAuthToken(token: string): boolean {
  const action = getTokenAction(token);
  return action === JwtTokenAction.ConfirmEmail || action === JwtTokenAction.TwoFactorAuth;
}

/** id пользователя из access-токена (`id` в payload); null, если токен не разобрать или id нет. */
export function getTokenUserId(token: string): string | null {
  const id = parseJwtPayload(token)?.id;
  return typeof id === 'number' || typeof id === 'string' ? String(id) : null;
}
